let reyMandaPicante = [
    'Tenés que hacerle un striptease a la persona a tu derecha.',
    'Cachetea al de tu izquierda en donde quieras.',
    'Tenés 5 minutos en el baño con la persona a tu izquierda.',
    'Todos los que tengan las uñas pintadas te tienen que dar un pico.',
    'Todos los hombres se tienen que dar un pico.',
    'Toman los que hayan tenido relaciones sexuales en una carpa.',
    'Nombrá tres cosas que sean mejores cuando están mojadas. Si no podés, tomás 3 tragos.',
    'Tomá si le das a alguien que esté presente.',
    'Toman los putakus.',
    'Tenés que sentarte arriba de la persona que esté a tu izquierda por una ronda.',
    'Botellita.',
    'Subí a la historia una foto beboteando.',
    'Tenés que decir tres cosas que todos los hombres dicen mientras tienen relaciones sexuales o tomar 3 tragos.',
    'Toman los que alguna vez se les haya roto el preservativo mientras estaban teniendo relaciones sexuales.',
    'Toman los que tendrían sexo por plata.',
    'Describí tu fantasía sexual o tomá 3 tragos.',
    'Recomendá un juguete sexual a modo de publicidad.',
    'Todos tienen que hablar como el de EloPodcast por una ronda.',
    'Toma la persona que haya tenido mayor cantidad de relaciones sexuales en el mismo día.',
    'Toman los que hayan sido infieles.',
    'Vos, la persona que tenés en frente y la persona que esté a su derecha tienen que darse un beso.',
    'Tenés que hacerle un meneo sensual por 30 segundos a la persona que esté a tu derecha.',
    'Sin repetir y sin soplar: formas de decirle al sexo. El primero que no sabe toma 4 tragos',
    'Toma el que haya tenido sexo más recientemente',
    'Vos y la persona a tu derecha tienen que recomendar una pose sexual y fundamentar.',
    'Vos y la persona a tu izquierda tienen que mostrar la foto más picante que tengan en el celular.',
    'Toman los que tuvieron relaciones sexuales hace menos de 3 meses.',
    'Toman los que disfruten ver hentai.',
    'Decí la parte que más te gusta de la persona a tu derecha',
    'Toman los que alguna vez sextearon.',
    'Tenés que mostrar tu ropa interior.',
    'Sin repetir y sin soplar: categorías de porno. El primero que no sabe toma 4 tragos',
    'Toman los que alguna vez le tuvieron ganas a un amigo.',
    'Sin repetir y sin soplar: lugares para un rapidito. El primero que no sabe toma 3 tragos.',
    'Toman los que sepan tres nombres o más de actrices porno.',
    'Tenés que darle tres besos en el cuello a la persona a tu derecha.',
    'Todos los jugadores te tienen que dar un beso en cualquier parte del cuerpo. No vale repetir.',
    'Le tenés que acariciar la pierna a la persona que esté a tu izquierda.',
    'Sin repetir y sin soplar: formas de decirle al sexo. El primero que no sabe toma 4 tragos.',
    'Toma 2 tragos la persona que este más cerca de abrirse un OnlyFans.',
    'Tomá si alguna vez encontraste a alguno de los jugadores en Tinder.',
    'Nombra tres lugares en donde te gustaría tener sexo o tomá 2 tragos.',
    'Nombra tres lugares en donde te masturbaste o tomá 2 tragos.',
    'Toman los que alguna vez estuvieron con el hermano/a de un amigo/a.',
    'Toman los que miran porno moralmente cuestionables.',
    'Toman los que les guste hablar sucio.',
    'Sin repetir y sin soplar: frases que podés decir en una cena familiar y durante el sexo. El primero que no sabe toma 4 tragos.',
    'Nombrá la persona que diría que una paja no es cagar a alguien. Toma 5 trago.',
    'Sin repetir y sin soplar: roleplays que se podrían hacer. El primero que no sabe toma 4 tragos.',
    '¿A qué edad tuviste tu primera vez? Tomá la mitad.',
    'Toma el jugador con más probabilidades de tener un hijo no reconocido.',
    'Sin repetir y sin soplar: cosas que podés usar en el sexo. El primero que no sabe toma 4 tragos',
    'Toma el que haya tenido sexo más recientemente.',
    'Si estuviste con alguien que estaba en pareja tomá 4 tragos. Si todavía siguen en pareja tomá 2 tragos más.',
    'Describí tu mejor experiencia sexual o tomá 5 tragos.',
    'Todos toman un trago por cada persona con la que tuvieron sexo.',
    'Tenés que decir tres acciones que se realicen cuando tenés sexo o tomá 5 tragos.',
    'Decí tu posición preferida o tomá 6 tragos.',
    'Tomá 1 trago si hablaste con un match en Tinder, 3 tragos si saliste a tomar algo y 5 si estuvieron.',
    'Deci tres insultos que se podrían decir mientras estás teniendo sexo o tomá 4 tragos.',
    'Sin repetir y sin soplar: tipos de preservativos. El primero que no sabe toma 3 tragos.',
    'Dale un beso en la boca al jugador que esté a tu derecha o tomá 6 tragos.',
    'Toman todos los que tengan preservativos en este momento.',
    'Le tenes que chupar el cuello al jugador de tu izquierda o tomá 6 tragos.',
    'Toman los que alguna vez se hayan medido del pene.',
    'Tocale la entrepierna al jugador que esté a tu derecha o tomá 6 tragos.',
    'Le tenés que tocar el culo al jugador de tu derecha.',
    'Dale un beso en la boca al jugador de tu izquierda.',
    'Tenés que hacerle masajes en los pies al jugador de tu izquierda por tres minutos. Si no, tomás 7 tragos.',
    'Tomás 2 tragos por cada prenda que se saque el jugador que tenés en frente.',
    'Toman todos los que quieran tener sexo esta noche.',
    'Tenés que elegir un jugador para que los dos chupen un objeto fálico. Toma el que menos recorrido haya hecho.',
    'Tenés que chuparle el dedo al jugador a tu derecha.',
    'Sin repetir y sin soplar: verduras que tienen forma de pene. El primero que no sabe toma 3 tragos.',
    'Tenés que susurrarle al jugador a tu derecha "como te la chuparía".',
    '¿Quién pensás que está más caliente? Toma 3 tragos.',
    'Vos y la persona que tenés a tu derecha tienen que pasarse un hielo con la boca.',
    'Recreá tu posición preferida con la persona a tu derecha o tomá 6 tragos.',
    'Contá lo más raro que hiciste en la intimidad o tomá 6 tragos.',
    'Hacele un chupón al jugador a tu derecha o tomá 6 tragos. Si el jugador a tu derecha no quiere toma 7 tragos.',
    'Dale 4 tragos al jugador que más lindo te parezca.',
    'Tenés que fingir un orgasmo o tomar 7 tragos.',
    'Dale un trago a la persona que vos pienses que más la vive cuando tiene relaciones sexuales.',
    '¿A qué jugador te gustaría más ver desnudo?. Si no respondes tomás 6 tragos.',
    'Tenés que mostrar tu mejor versión de beboteo o tomar 6 tragos.'
]

export default reyMandaPicante